export const positions = [
  { key: "no", value: "", text: "None" },
  { key: "gk", value: "Goalkeeper", text: "Goalkeeper" },
  { key: "cb", value: "Corner back", text: "Corner back" },
  { key: "fb", value: "Full back", text: "Full back" },
  { key: "wb", value: "Wing back", text: "Wing back" },
  { key: "ctb", value: "Center back", text: "Center back" },
  { key: "mf", value: "Midfield", text: "Midfield" },
  { key: "wf", value: "Wing forward", text: "Wing forward" },
  { key: "ctf", value: "Center forward", text: "Center forward" },
  { key: "cf", value: "Corner forward", text: "Coner forward" },
  { key: "ff", value: "Full forward", text: "Full forward" }
];



// WEBPACK FOOTER //
// ./src/data/positions.data.js